import { useEffect, useState, useRef } from "react";
import { resolveUrl } from "@/cms/ContentContext";
import { uploadImage } from "@/cms/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

export const Field = ({ label, value, onChange, testid, multiline = false, placeholder = "" }) => (
  <label className="flex flex-col gap-2">
    <span className="overline text-[#6B6554]">{label}</span>
    {multiline ? (
      <textarea
        data-testid={testid}
        className="ordo-field"
        rows={3}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    ) : (
      <input
        data-testid={testid}
        className="ordo-field"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    )}
  </label>
);

export const ImagePicker = ({ label, value, onChange, testid }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const { url } = await uploadImage(file);
      onChange(url);
      toast.success("Imagem carregada.");
    } catch (err) {
      toast.error("Erro no upload");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex flex-col gap-3" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="overline text-[#6B6554]">{label}</span>
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="text-xs text-[#8C714D] hover:text-[#3A3524] flex items-center gap-1"
          >
            <X size={12} /> Remover
          </button>
        )}
      </div>
      <div className="relative aspect-[4/5] w-full max-w-xs bg-[#EAE5D9] border border-[#3A3524]/12 overflow-hidden">
        {value ? (
          <img src={resolveUrl(value)} alt="" className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-[#6B6554] font-serif italic text-sm">
            Sem imagem
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="inline-flex items-center gap-2 border border-[#3A3524]/40 hover:border-[#3A3524] text-[#3A3524] px-4 py-2 text-[11px] tracking-[0.2em] uppercase transition-colors"
        >
          <Upload size={14} /> {busy ? "A carregar…" : "Carregar"}
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={onFile}
          className="hidden"
        />
        <input
          className="ordo-field flex-1 min-w-[220px]"
          placeholder="ou colar URL da imagem"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};
